module.exports = __webpack_public_path__ + "img/07_full.9ab378db.jpg";